import { Mobile } from 'icon'

import IconBtn from './IconBtn'

const Btn = (props) => {
  return <IconBtn icon={<Mobile />} {...props} />
}

export default Btn
